import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './hooks/useAuth'
import Home from './pages/Home'
import Projects from './pages/Projects'
import Editor from './pages/Editor'
import Login from './pages/Login'
import Signup from './pages/Signup'
import Dashboard from './pages/Dashboard'
import ApexOffice from './pages/openclaw-hq'

function PrivateRoute({ children }) {
  const { user, loading } = useAuth()
  if (loading) return <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',background:'#0a0a0a',color:'#e8420a',fontFamily:'monospace',fontSize:14}}>🐉 Loading...</div>
  return user ? children : <Navigate to="/login" />
}

function OwnerRoute({ children }) {
  const { user, isOwner, loading } = useAuth()
  if (loading) return null
  return user && isOwner ? children : <Navigate to="/" />
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/" element={<PrivateRoute><Home /></PrivateRoute>} />
      <Route path="/projects" element={<PrivateRoute><Projects /></PrivateRoute>} />
      <Route path="/editor/:id" element={<PrivateRoute><Editor /></PrivateRoute>} />
      <Route path="/dashboard" element={<OwnerRoute><Dashboard /></OwnerRoute>} />
      <Route path="/chat" element={<PrivateRoute><Navigate to="/" /></PrivateRoute>} />
      <Route path="/office" element={<PrivateRoute><ApexOffice /></PrivateRoute>} />
    </Routes>
  )
}
